import { api } from './api';

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  message: string;
  data?: {
    propertyId?: string;
    listingId?: string;
    oldPrice?: number;
    newPrice?: number;
    changePercent?: number;
    naverArticleNo?: string;
    targetPrice?: number;
    currentMinPrice?: number;
    alertId?: string;
  };
  isRead: boolean;
  createdAt: string;
}

export async function getNotifications(
  page = 1,
  limit = 20,
  unreadOnly = false,
  type?: string,
): Promise<{ data: Notification[]; meta: { page: number; limit: number; total: number; totalPages: number } }> {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (unreadOnly) params.set('unreadOnly', 'true');
  if (type) params.set('type', type);
  const res = await api.get(`/notifications?${params}`);
  return { data: res.data.data, meta: res.data.meta };
}

export async function getUnreadCount(): Promise<number> {
  const res = await api.get('/notifications/unread');
  return res.data.data.count;
}

export async function markAsRead(id: string): Promise<void> {
  await api.put(`/notifications/${id}/read`);
}

export async function markAllAsRead(): Promise<void> {
  await api.put('/notifications/read-all');
}
